import SEO from "@/components/SEO";
import { PageHero } from "@/components/common/Bits";
import { Reveal } from "@/components/motion/Reveal";
import ServiceCard from "@/components/ui/ServiceCard";
import { SERVICES } from "@/data/services";

export default function ServicesIndex() {
    return (
        <>
            <SEO
                title="Services — One-Stop Property Care Singapore"
                path="/services"
                description="Moving, cleaning, painting, aircon servicing, floor polishing, handyman, repairs and disposal — all your property services under one roof."
            />
            <PageHero
                label="Our Services"
                title="Everything Your Property Needs"
                subtitle="From moving day to move-in ready — explore the full range of ProCare.SG property services."
                image="/images/hero-team.webp"
            />
            <section className="py-24">
                <div className="mx-auto max-w-7xl px-6">
                    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                        {SERVICES.map((s, i) => (
                            <Reveal key={s.slug} delay={i * 0.05}>
                                <ServiceCard service={s} />
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
